
let styles = {
    container: {
      padding: '3%',
      
      display: 'flex',
      justifyContent: 'center',
      display: 'flex',
      textAlign:'center',
      float:'center',
      flexDirection: 'column',
    },
    table: {
        
        borderStyle:'outset',
        padding: '1%',
        width:'100%',
        marginLeft:'0%',
        marginTop:'10px'
    },
    items: {
        padding: '1%',
    },
    
    item_header: {
        fontSize: '120%',
        fontWeight: 600,
        paddingLeft: '5%',
    },
    
    item_body: {
        padding: '6px ',
    },
    
    main_header: {
        padding: '1%',
        marginBottom: '3%',
        backgroundColor: '#CD85F9',
        fontSize:'20px',
        textAlign:'center',
    },

    input: {
        width: '90%',
        height: 25,
        backgroundColor:'#E9E1F9'
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureSession/style.js